/**!
 *
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 * @private
 */

import '@ciscospark/plugin-user';
import '@ciscospark/plugin-wdm';

import {registerPlugin} from '@ciscospark/spark-core';
import Avatar from './avatar';
import config from './config';

registerPlugin(`avatar`, Avatar, {
  config
});

export {default as default} from './avatar';
